import React from "react";
import DefaultBlock from "../../components/main/DefaultBlock";
import { Grid, Typography } from "@mui/material";
import { Button, Box } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Link as RouterLink } from "react-router-dom";

import BlueprintBlock from "../../components/main/BlueprintBlock";
import Profile from "../../components/main/Profile";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { IconButton, Tooltip } from "@mui/material";
import BlogColumn from "../../components/main/BlogColumn";

import LaunchIcon from "@mui/icons-material/Launch";
import ProjectGallery from "../../components/misc/ProjectGallery";
import SEO from "../../components/misc/SEO";

const sampleProjects = [
  {
    title: "Argento",
    icon: "/p/sites/arg-logo.png",
    images: [
      "/p/sites/arg-1.jpg",
      "/p/sites/arg-2.jpg",
      "/p/sites/arg-3.jpg",
      "/p/sites/arg-4.jpg",
      "/p/sites/arg-5.jpg",
      "/p/sites/arg-6.jpg",
    ],
    link: "/blog/argento",
  },
  {
    title: "Sentinel",
    icon: "/p/sites/sen-logo.png",
    images: [
      "/p/sites/sen-1.jpg",
      "/p/sites/sen-2.jpg",
      "/p/sites/sen-3.jpg",
      "/p/sites/sen-4.jpg",
      "/p/sites/sen-5.jpg",
    ],
    link: "/blog/sentinel",
  },
  {
    title: "Fangate.io",
    icon: "/p/sites/fan-logo.png",
    images: [
      "/p/sites/fan-1.jpg",
      "/p/sites/fan-2.jpg",
      "/p/sites/fan-3.jpg",
      "/p/sites/fan-4.jpg",
      "/p/sites/fan-5.jpg",
      "/p/sites/fan-6.jpg",
    ],
    link: "/blog/fangate-io",
  },
];

export default function WebPort() {
  return (
    <div>
      <SEO
        title="Portfolio | Aaron Hunt"
        image="https://www.aaronhunt.dev/p/web.jpg"
      />
      <BlueprintBlock text="export default webDemo() {" />
      <DefaultBlock>
        <Grid container sx={{ width: "100%" }}>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              width: { md: "50%" },
              boxSizing: "border-box",
              pr: { md: 1 },
            }}
          >
            <Box
              sx={{
                py: 8,
                px: 2,
                pb: "20px",
                backgroundColor: "transparent",
                textAlign: "left",
                maxWidth: "100%",
              }}
            >
              <Typography sx={{ pb: 2, maxWidth: "512px", opacity: 0.5 }}>
                Aaron Hunt
              </Typography>
              <Typography variant="h4" fontWeight="bold">
                Junior Frontend Developer
              </Typography>
              <Typography sx={{ pt: 2, maxWidth: "512px", opacity: 0.8 }}>
                Whether you're building a web application, a game, or something
                in between, I’m here to help.
              </Typography>
            </Box>

            <Box sx={{ px: 2, mt: 3, display: "flex", gap: 2 }}>
              {[
                {
                  label: "Technologies",
                  to: "/technologies",
                  color: "primary",
                },
                { label: "About Me", to: "/blog/about-me", color: "secondary" },
              ].map(({ label, to, color }) => (
                <Button
                  key={label}
                  variant="contained"
                  color={color}
                  target="_blank"
                  component={RouterLink}
                  to={to}
                  endIcon={<ArrowForwardIosIcon sx={{ height: 14 }} />}
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                    "& .MuiButton-endIcon": {
                      opacity: 0.5,
                      transform: "translateX(-2px)",
                      transition: "all 0.3s ease",
                    },
                    "&:hover .MuiButton-endIcon": {
                      opacity: 1,
                      transform: "translateX(2px)",
                    },
                  }}
                >
                  {label}
                </Button>
              ))}
            </Box>
            <Box sx={{ display: "flex", gap: 1.5, px: 2, mt: 4, opacity: 0.6 }}>
              <Tooltip title="GitHub">
                <IconButton
                  component="a"
                  href="https://github.com/anhuntz/aaron-hunt-portfolio"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <GitHubIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="LinkedIn">
                <IconButton
                  component="a"
                  href="https://www.linkedin.com/in/aaron-h-36332412b/"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <LinkedInIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="YouTube">
                <IconButton
                  component="a"
                  href="https://www.youtube.com/@aaronhunt7204"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <YouTubeIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Blog">
                <IconButton
                  component="a"
                  href="/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                >
                  <img
                    src="/logo.svg"
                    alt="Custom Icon"
                    style={{ height: 24, width: 24 }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              width: { md: "50%" },
              boxSizing: "border-box",
              pl: { md: 1 },
            }}
          >
            <Profile />
          </Grid>
        </Grid>
      </DefaultBlock>
      <BlueprintBlock text="load portfolio" />

      <DefaultBlock>
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Work Examples
        </Typography>
        <Box className="backgroundDots">
          <Grid
            container
            spacing={3}
            justifyContent="center"
            sx={{ maxWidth: 1200, mx: "auto", pt: 2 }}
          >
            {sampleProjects.map((project, idx) => (
              <Grid item key={idx} xs={12} sm={6} md={4} lg={3} xl={2.4}>
                <ProjectGallery
                  title={project.title}
                  icon={project.icon}
                  images={project.images}
                  link={project.link}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </DefaultBlock>

      <BlueprintBlock text="load projects(type: web)" />
      <DefaultBlock>
        <Typography variant="h5" sx={{ p: 2, maxWidth: "512px", opacity: 0.8 }}>
          Other Relevant Projects
        </Typography>
        <BlogColumn showProjects={true} limit={5} category="Web" />
        <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            color="secondary"
            href="/blog"
            rel="noopener noreferrer"
            startIcon={<LaunchIcon />}
            sx={{ mt: 2, mb: 3 }}
          >
            View More Projects
          </Button>
        </Box>
      </DefaultBlock>
    </div>
  );
}
